export const COLLECT_PERIODS_CONFIG = {
  name: {
    key: "name",
    label: "Nombre",
  },
  type: {
    key: "type",
    label: "Tipo",
  },
  cutDay: {
    key: "cutDay",
    label: "Dia de Corte",
  },
  payDay: {
    key: "payDay",
    label: "Dias de Credito",
  },
};

export const COLLECT_PERIODS_PHRASE = {
  page: {
    table: {
      title: "Catalogo de Periodos de Cobro",
    },
  },
  modal: {
    titles: {
      edit: "Modificar Periodo de Cobro",
      add: "Agregar Nuevo Periodo de Cobro",
      delete: "¿Estas seguro de eliminar este periodo de cobro?",
    },
    actions: {
      cancel: "Cancelar",
      add: "Agregar",
      delete: "Eliminar",
      save: "Guardar",
      edit: "Editar",
    },
  },
  search: {
    messages: {
      noStations: "No se ha seleccionado alguna planta.",
    },
  },
  form: {
    dropdowns: {
      route: "Seleccione una Ruta",
      type: "Seleccione una Periodo de Cobor",
      employee: "Seleccione un Empleado",
      status: "Seleccione un Estado",
    },
  },
};
